<template>
  <div
    v-if="!allSelected"
    class="bg-white rounded-xl border-dashed border-2 overflow-hidden p-2 w-full cursor-pointer"
    @click="linkFan()"
  >
    <div class="h-full text-center flex flex-wrap justify-center content-center p-1">
      <p class="text-gray-400">
        <i class="pi pi-plus"></i> {{lang['components']['LinkAccount']['AddCard']['link_fan_page_button_text']}}
        </p>
    </div>
  </div>
  <div
    v-if="allSelected"
    class="bg-white rounded-xl border-dashed border-2 overflow-hidden p-2 w-full cursor-pointer"
    @click="toFbBusinessTools()"
  >
    <div class="h-full text-center flex flex-wrap justify-center content-center p-1">
      <p class="text-gray-400">
        {{lang['components']['LinkAccount']['AddCard']['no_fan_page']}}
      </p>
    </div>
  </div>
  <ConnectFanPageDialog v-bind:lang="lang" v-model:show="showModal" v-model:connectId="connectIdData"/>
</template>

<script>
  import ConnectFanPageDialog from '@/components/Dialog/ConnectFanPageDialog.vue'
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import axios from 'axios'
  import Qs from 'qs'

  export default {
    name: 'AddCard',
    props: {
      connectId: {
        type: String,
        default: 'test'
      },
      lang: {
        type: Object
      },
      allSelected: {
        type: Boolean,
        default: false
      }
    },
    components: {
      ConnectFanPageDialog
    },
    data() {
      return {
        showModal: false
      }
    },
    methods: {
      linkFan(){
        let member_hash = this.$route.params.id
        let type = this.$route.params.type

        axios
          .post('https://test.autoturn.net/inside/api/campaign_member_status.php', Qs.stringify({
            s_code: member_hash,
            route_type: type,
            active: 'member',
          }))
          .then((caResponse) => {

            if(caResponse.data.status == 'error'){
              if(caResponse.data.type == 2){
                Swal.fire({
                  icon: caResponse.data.status,
                  title: this.lang['components']['LinkAccount']['AddCard']['linkFan']['error']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.lang['components']['LinkAccount']['AddCard']['linkFan']['error']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    // Swal.fire('Saved!', '', 'success')
                    this.allPageLoading = true
                    window.location.href = "https://dev-private.autoturn.net/"+type+"/"+member_hash;
                  } else if (result.isDenied) {
                    // Swal.fire('Changes are not saved', '', 'info')
                    this.allPageLoading = true
                    window.location.href = "https://dev-private.autoturn.net/"+type+"/"+member_hash;
                  }
                })
              } else if(caResponse.data.type == 3){
                Swal.fire({
                  icon: caResponse.data.status,
                  title: this.lang['components']['LinkAccount']['AddCard']['linkFan']['error']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.lang['components']['LinkAccount']['AddCard']['linkFan']['error']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  // if (result.isConfirmed) {
                  //   // Swal.fire('Saved!', '', 'success')
                  //   this.allPageLoading = true
                  //   window.location.href = "http://localhost:8080/"+member_hash;
                  // } else if (result.isDenied) {
                  //   // Swal.fire('Changes are not saved', '', 'info')
                  //   this.allPageLoading = true
                  //   window.location.href = "http://localhost:8080/"+member_hash;
                  // }

                  // if (result.dismiss === Swal.DismissReason.timer) {
                  //   this.allPageLoading = true
                  //   window.location.href = "http://localhost:8080/"+member_hash;
                  // }
                })
              } else {
                Swal.fire(
                          this.lang['components']['LinkAccount']['AddCard']['linkFan']['error']['swal_title'],
                          caResponse.data.info,
                          caResponse.data.status
                        )
              }
            }

            if(caResponse.data.status == 'warning'){
              Swal.fire({
                icon: 'warning',
                title: this.lang['components']['LinkAccount']['AddCard']['linkFan']['warning']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['components']['LinkAccount']['AddCard']['linkFan']['warning']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  this.showModal = true;
                }
              });
            }

            if(caResponse.data.status == 'success'){
              this.showModal = true;
            }

            if(caResponse.data.status == 'login'){
              Swal.fire({
                icon: 'error',
                title: this.lang['components']['LinkAccount']['AddCard']['linkFan']['login']['swal_title'],
                text: this.lang['components']['LinkAccount']['AddCard']['linkFan']['login']['swal_text'],
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['components']['LinkAccount']['AddCard']['linkFan']['login']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  // this.allPageLoading = true
                  window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  // this.allPageLoading = true
                  window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                }
              })
            }
          });
      },
      toFbBusinessTools(){
        window.open("https://www.facebook.com/settings?tab=business_tools&ref=settings");
      }
    },
    computed: {
      connectIdData: {
        get: function () {
          return this.connectId
        },
        set: function (value) {
          this.$emit('update:connectIdData', value)
        },
      }
    }
  }
</script>

<style scoped>

</style>